import React from 'react'
import Svg from '../../../../shared/Svg'

export const HelocSvg = () => (
  <Svg
    width='54'
    height='47'
    viewBox='0 0 54 47'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M46.5953 46.1321H7.56053C6.58056 46.1321 5.78622 45.3377 5.78622 44.3577V26.6147H48.3696V44.3577C48.3696 45.3377 47.5752 46.1321 46.5953 46.1321Z'
      fill='#C4BCC4'
    />
    <path
      d='M50.6632 26.0951L39.4978 14.9295L38.091 16.3364L48.3693 26.6148H51.9179C51.4639 26.6148 51.0098 26.4415 50.6632 26.0951Z'
      fill='#535058'
    />
    <path
      d='M46.595 46.1317H25.3034C24.3234 46.1317 23.5291 45.3373 23.5291 44.3574V26.6143L35.9492 14.1942L48.3693 26.6143V44.3574C48.3693 45.3373 47.575 46.1317 46.595 46.1317Z'
      fill='#F4EBF0'
    />
    <path
      d='M41.1372 11.7414C40.8625 11.0783 40.2154 10.6461 39.4978 10.6461H14.6575C14.1869 10.6461 13.7357 10.833 13.4029 11.1657L0.982742 23.5859C0.475291 24.0933 0.323477 24.8565 0.598162 25.5195C0.872846 26.1826 1.5198 26.6148 2.2374 26.6148H27.0777C27.5483 26.6148 27.9995 26.4278 28.3323 26.0952L40.7525 13.675C41.2599 13.1676 41.4118 12.4044 41.1372 11.7414Z'
      fill='#68646B'
    />
    <path
      d='M28.8522 14.1942H12.8834C11.9034 14.1942 11.1091 14.9885 11.1091 15.9685C11.1091 16.9484 11.9034 17.7428 12.8834 17.7428H28.8522C29.8321 17.7428 30.6265 16.9484 30.6265 15.9685C30.6265 14.9885 29.8321 14.1942 28.8522 14.1942Z'
      fill='#302E35'
    />
    <path
      d='M15.2635 17.7431H26.4721C28.9828 15.9755 30.6265 13.0556 30.6265 9.75869C30.6265 4.37777 26.2487 0 20.8678 0C15.4869 0 11.1091 4.37777 11.1091 9.75869C11.1091 13.0556 12.7529 15.9755 15.2635 17.7431Z'
      fill='#FD5AA7'
    />
    <path
      d='M25.2788 11.61C25.2788 12.348 25.0025 12.9883 24.4499 13.5307C23.9064 14.0643 23.1143 14.4067 22.0734 14.5578V16.0384H20.4154V14.6112C19.7246 14.5667 19.0706 14.4556 18.4535 14.2777C17.8364 14.091 17.3252 13.8642 16.9199 13.5974L17.818 11.65C18.2509 11.9256 18.7529 12.148 19.3239 12.3169C19.895 12.4859 20.4569 12.5704 21.0096 12.5704C22.0596 12.5704 22.5846 12.3169 22.5846 11.81C22.5846 11.5433 22.4326 11.3476 22.1287 11.2231C21.8339 11.0898 21.355 10.9519 20.6918 10.8096C19.9641 10.6585 19.3562 10.4984 18.868 10.3294C18.3798 10.1516 17.9607 9.87148 17.6107 9.4891C17.2607 9.10672 17.0857 8.59096 17.0857 7.94181C17.0857 7.17705 17.3712 6.52345 17.9423 5.98101C18.5134 5.42967 19.3378 5.09176 20.4154 4.96726V3.5H22.0734V4.94059C22.5984 4.98505 23.1004 5.07397 23.5794 5.20736C24.0676 5.34075 24.5005 5.51415 24.8782 5.72757L24.0354 7.68837C23.1143 7.20817 22.2208 6.96808 21.355 6.96808C20.8115 6.96808 20.4154 7.04811 20.1668 7.20817C19.9181 7.35935 19.7937 7.55943 19.7937 7.80842C19.7937 8.05741 19.9411 8.24415 20.2358 8.36865C20.5306 8.49314 21.0049 8.62208 21.6589 8.75547C22.3958 8.90664 23.0037 9.07115 23.4827 9.249C23.9709 9.41796 24.39 9.69363 24.74 10.076C25.0992 10.4495 25.2788 10.9608 25.2788 11.61Z'
      fill='white'
    />
    <path
      d='M51.918 26.6148C51.4639 26.6148 51.0099 26.4416 50.6633 26.0952L39.4978 14.9296L28.3323 26.0952C27.6394 26.788 26.516 26.788 25.823 26.0952C25.1302 25.4022 25.1302 24.2788 25.823 23.5859L38.2432 11.1657C38.9362 10.4728 40.0595 10.4728 40.7525 11.1657L53.1726 23.5859C53.8655 24.2788 53.8655 25.4022 53.1726 26.0952C52.8262 26.4416 52.3721 26.6148 51.918 26.6148Z'
      fill='#8E8C96'
    />
    <path
      d='M5.78622 26.6147H23.5293V30.1633H5.78622V26.6147Z'
      fill='#B5ADB1'
    />
    <path
      d='M35.9494 31.9377C33.0096 31.9377 30.6265 34.3208 30.6265 37.2606V46.1321H41.2723V37.2606C41.2723 34.3208 38.8892 31.9377 35.9494 31.9377Z'
      fill='#68646B'
    />
  </Svg>
)

export default HelocSvg
